import Controller from "./basicplans.controller";
import template from "./basicplans.html";

const basicplans = {
  template,
  controller: Controller,
};

export default basicplans;



// WEBPACK FOOTER //
// ./src/pages/basicplans/basicplans.component.js